import { connect } from 'react-redux';
import { NotificationWatcherDecisionType } from '../../../notification.types';
import { StateType } from '../../../../../state/state.types';

const mapState = (
  { notifications }: StateType,
  { notification }: { notification: NotificationWatcherDecisionType },
) => ({
  isAlreadyRead: !!notifications.notifReadStatusMap[notification.id],
});

export const Connect = connect(mapState);
